import { render, staticRenderFns } from "./DetailGallery.vue?vue&type=template&id=5e0d0b58&"
import script from "./DetailGallery.vue?vue&type=script&lang=js&"
export * from "./DetailGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports